import { render, staticRenderFns } from "./EmployeesClocks.vue?vue&type=template&id=40e4d85c&scoped=true&"
import script from "./EmployeesClocks.vue?vue&type=script&lang=js&"
export * from "./EmployeesClocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4d85c",
  null
  
)

export default component.exports